import * as React from 'react';

interface ILabelProps {
    label: string;
}

const Label = (props: ILabelProps) => {
    const { label } = props;

    if (!label) {
        return null;
    }

    return (
        <label>{label}:</label>
    );
};

export default Label;
